<template>
  <div class="page-container products-list">
    <div class="page-title-container">
      <h1 class="page-title">Lista de cotizaciones</h1>
    </div>
    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-flex d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por Nro de cotización, Nro de documento, teléfono, email o persona de contacto"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'tools-quotes-form' }"
                  variant="none"
                  class="button button-primary ml-md-2"
                  >Agregar</b-button
                >
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div>

        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>N° de cotización</span>
            </div>
            <div>
              <span>Fecha de cotización</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.correlationId }}</span>
                </div>

                <div class="pl-3">
                  <span>{{ getQuoteCreatedAt(o.createdAt) }}</span>
                </div>

                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{ name: 'tools-quotes-edit', params: { id: o.id } }"
                  v-if="o.status == LocalConstants.QuoteStatus.DRAFT.key"
                >
                  Editar
                </router-link>

                    <a href="" class="ml-2" @click.prevent="openDelete(o)" v-if="o.status == LocalConstants.QuoteStatus.DRAFT.key">Eliminar</a>

                <a
                  href=""
                  class="ml-2"
                  @click.prevent="downloadQuote(o.id)"
                  v-if="
                        o.status == LocalConstants.QuoteStatus.GENERATED.key
                      "
                  >Descargar</a
                >

                <a
                  href=""
                  class="ml-2"
                  @click.prevent="cloneQuote(o.id)"
                  v-if="
                        o.status == LocalConstants.QuoteStatus.GENERATED.key
                      "
                  >Duplicar</a
                >
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >N° de documento:</span
                    >
                    <span class="d-inline-block ml-1">
                      {{ o.customerIdentifier || '' }}
                    </span>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Razón social/nombre:</span
                    >
                    <span class="d-inline-block ml-1">{{ o.customerFullName || "-" }}</span>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Contacto:</span
                    >
                    <span class="d-inline-block ml-1">{{ o.customerContact || "-" }}</span>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Teléfono:</span
                    >
                    <span class="d-inline-block ml-1">{{ o.customerMobile || "-" }}</span>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Correo electrónico:</span
                    >
                    <span class="d-inline-block ml-1">{{ o.customerEmail || "-" }}</span>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Monto:</span
                    >
                    <span class="d-inline-block ml-1" v-decimal:pen="o.totalPlusDelivery"></span>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Estado:</span
                    >
                    <span :class="`badge ${getStatus(o.isActive).color}`">{{
                      getStatus(o.isActive).label
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>N° de cotización</th>
              <th>
                Fecha de <br />
                cotización
              </th>
              <th class="pl-md-4">
                N° de <br />
                documento
              </th>
              <th>Razón social/nombre</th>
              <th class="pr-md-2">Contacto</th>
              <th>Teléfono</th>
              <th class="px-md-2">Correo <br> electrónico</th>
              <th class="px-md-2">Monto</th>
              <th>Estado</th>
              <th class="pr-md-2">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="text-center pl-1">{{ o.correlationId }}</td>
              <td class="text-center px-1">{{ getQuoteCreatedAt(o.createdAt) }}</td>
              <td class="text-center">{{ o.customerIdentifier || '-' }}</td>
              <td class="pl-3">{{ o.customerFullName || "-" }}</td>
              <td class="text-center">
                {{ o.customerContact || "-" }}
              </td>
              <td class="text-center px-2">{{ o.customerMobile || "-" }}</td>
              <td class="text-center">{{ o.customerEmail || "-" }}</td>
              <td class="text-center px-1"><span v-decimal:pen="o.totalPlusDelivery"></span></td>
              <td class="text-center px-1">
                <span :class="`badge ${getStatus(o.status).color}`">{{
                  getStatus(o.status).label
                }}</span>
              </td>

              <td class="text-center d_option pr-md-4">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem :to="{ name: 'tools-quotes-edit', params: { id: o.id } }" text="Editar" v-if="o.status == LocalConstants.QuoteStatus.DRAFT.key" />

                    <DropdownItem
                    @click="openDelete(o)"
                      text="Eliminar"
                      v-if="o.status == LocalConstants.QuoteStatus.DRAFT.key"
                    />

                    <DropdownItem
                      text="Descargar"
                      @click="downloadQuote(o.id)"
                      v-if="
                        o.status == LocalConstants.QuoteStatus.GENERATED.key
                      "
                    />

                    <DropdownItem
                      text="Duplicar"
                      @click="cloneQuote(o.id)"
                      v-if="
                        o.status == LocalConstants.QuoteStatus.GENERATED.key
                      "
                    />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="table-footer d-flex justify-content-end align-items-center"
        v-if="list.length"
      >
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
        />
      </div>
    </div>

    <ConfirmationModal
      :show="confirmationModal.show"
      @hide="closeConfirmationModal"
      :data="confirmationModal"
      @confirm="confirmModal"
    />
  </div>
</template>

<script>
import {
  Alert,
  Constants,
  Util,
  PaginationMixin,
  FilterMixin,
  DropdownTable,
  DropdownItem,
  SearchBar,
  FilterMenu,
  ConfirmationModalMixin,
  ConfirmationModal
} from "wize-admin";

import QuoteMixin from "@/core/mixins/QuoteMixin";
import { Constants as LocalConstants } from "@/core/utils";
import { Helpers } from "@/core/utils";

import { QuoteService } from "@/core/services";

export default {
  mixins: [PaginationMixin, FilterMixin, ConfirmationModalMixin, QuoteMixin],
  data() {
    return {
      LocalConstants,
      list: [],
      tooltipType: null,
      selectedOption: null,
      filterOptions: [
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.QuoteStatus.DRAFT,
            LocalConstants.QuoteStatus.GENERATED,
          ],
        },
        {
          label: "Fecha de cotización",
          key: "createdAt",
          type: Constants.TypeFilters.DATE,
        },
      ],
    };
  },
  components: {
    SearchBar,
    FilterMenu,
    DropdownTable,
    DropdownItem,
    ConfirmationModal
  },
  methods: {
    async loadData() {
      try {
        this.$store.dispatch("app/loading", true);

        const params = {
          page: this.page - 1,
          size: this.pageSize,
          search: this.search,
          ...this.filters,
        };

        const response = await QuoteService.list(params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        })

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (error) {
        Alert.error(error);
        console.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getStatus(key) {
      return Util.searchValue(key, LocalConstants.QuoteStatus);
    },
    getQuoteCreatedAt(date) {
      return Helpers.localDate(date, "DD/MM/YYYY");
    },
    async downloadQuote(id) {
      const response = await this.getQuoteData(id);

      if (response) {
        let data = {
          ...response.customer,
          items: response.productList,
        };

        console.log('Data')
        console.log(data);
        
        let previewPDF = false;

        this.generatePDF(data, previewPDF);
      }
    },
    async cloneQuote(id) {
      const response = await this.getQuoteData(id);

      if (response) {
        let customer = response.customer;

        let productList = response.productList.map(({ productCode, quantity }) => {
          return {
            productCode,
            quantity,
          };
        })

        let data = {
          ...customer,
          items: productList,
          status: LocalConstants.QuoteStatus.DRAFT.key
        };

        try {
          let responseNewQuote = await QuoteService.save(data)

          if (responseNewQuote.status == "OK") {
            this.$router.push({name: 'tools-quotes-edit', params: { id: responseNewQuote.payload.id }})

            setTimeout(() => {
              this.$smoothScroll({
                scrollTo: document.querySelector("#quote-editor"),
                updateHistory: false
              })
            }, 500)
          }
        } catch (ex) {
          console.error(ex);
          Alert.error(ex.errors.message);
        } finally {
          this.$store.dispatch("app/loading", false);
        }
      }
    },
    openDelete(o) {
      this.selectedOption = o;
      this.openConfirmationModal({ acceptText: "Borrar", action: "delete" });
    },
    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "delete") this.deleteQuote();
    },
    async deleteQuote() {
      try {
        await this.$store.dispatch("app/loading", true);
        await QuoteService.delete(this.selectedOption.id);
        await this.loadData()
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message)
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    }
  },
  computed: {
    showFiltersList() {
      return Object.keys(this.filters).length >= 1;
    },
  },
  async mounted() {
    await this.loadData();
  },
};
</script>

<style lang="stylus" scoped></style>
